// What the edit dialog is allowed to do to an appointment.

interface CancellableAppointment {
  id?: string;
  status?: string;
}

/**
 * Whether the dialog should offer to cancel this appointment.
 *
 * Only two states say no: there is nothing to cancel yet (a new appointment
 * being created), and it has been cancelled already. Everything else is
 * offered, which is what the Appointments list does — the same appointment
 * must not be cancellable in one place and not the other.
 */
export function canCancelAppointment(appointment: CancellableAppointment | null): boolean {
  if (!appointment) return false;
  return appointment.status !== 'cancelled';
}
